// Generated by scripts/generate-branded-icons.ts — do not edit by hand.
export const paths: string[] = [
  'M2.15 11.62L11.62 2.15C12.19 1.58 13.11 1.58 13.67 2.15L13.85 2.33C14.42 2.89 14.42 3.81 13.85 4.38L4.38 13.85C3.81 14.42 2.89 14.42 2.33 13.85L2.15 13.67C1.58 13.11 1.58 12.19 2.15 11.62Z',
  'M10.07 3.7L12.3 5.93',
  'M3.42 1.63C3.49 1.48 3.71 1.48 3.78 1.63L4.24 2.73C4.28 2.82 4.36 2.9 4.45 2.94L5.57 3.42C5.72 3.49 5.72 3.71 5.57 3.78L4.45 4.26C4.36 4.3 4.28 4.38 4.24 4.47L3.78 5.57C3.71 5.72 3.49 5.72 3.42 5.57L2.96 4.47C2.92 4.38 2.84 4.3 2.75 4.26L1.63 3.78C1.48 3.71 1.48 3.49 1.63 3.42L2.75 2.94C2.84 2.9 2.92 2.82 2.96 2.73L3.42 1.63Z',
  'M11.3 11.7H13.7M12.5 10.5V12.9',
];
